import React, { useEffect, useState } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import Upload from '../../../../components/Input/Upload';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { GET, newFetch, POST } from '../../../../helpers/fetch';
import { getClientSites } from '../../../../helpers/general';
import AppContext from '../../../../store/App/contexts';
import LayoutContext from '../../../../store/Layout/contexts';

const AddClaim = ({ history }) => {
  const accessType = localStorage.getItem('type');
  const {
    fetchClientsOptions,
    client_options,
    selectedClientID,
    fetchSiteOptions,
    site_options,
    selectedSiteID,
  } = React.useContext(AppContext);
  const clientID = parseInt(selectedClientID, 10);
  const siteID = parseInt(selectedSiteID, 10);
  const availableSites = getClientSites(clientID).map((allowedSite) => ({
    ...(site_options || []).find(
      (siteOption) => Number(siteOption.id) === Number(allowedSite.id)
    ),
    ...allowedSite,
  }));
  const availableSitesKey = availableSites.map((option) => option.id).join(',');
  const [statusOptions, setStatusOptions] = useState([]);
  const [status, setStatus] = useState(0);
  const [client, setClient] = useState('');
  const [associates, setAssociates] = useState([]);
  const [claimTypes, setClaimTypes] = useState([]);
  const [selectedAssociate, setSelectedAssociate] = useState(0);
  const [type, setType] = useState(0);
  const [dateReceipt, setDateReceipt] = useState('');
  const [amount, setAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [uploads, setUploads] = useState([]);
  const [site, setSite] = useState('');
  const [selectedClient, setSelectedClient] = useState([]);

  const fetchStatusOptions = async () => {
    let api_path = `/fields/claim_status`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setStatusOptions(response.data);
    }
  };

  const fetchClients = async (selectedClientID) => {
    let response = await newFetch(GET, `/client/${selectedClientID}`);
    if (response.success) setSelectedClient(response.data);
  };

  const fetchAssociates = async (selectedSite) => {
    if (!clientID || !selectedSite) {
      setAssociates([]);
      return;
    }

    try {
      let api_path = `/active_associate/client/${clientID}/site/${selectedSite}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setAssociates(response.data);
      } else {
        ToastUtil.error(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchTypes = async (selectedSite) => {
    if (!clientID || !selectedSite) {
      setClaimTypes([]);
      return;
    }

    try {
      let api_path = `/claimtypes/${selectedSite}?client_id=${clientID}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let claimTypes = response.data;

        setClaimTypes(claimTypes);
      } else {
        ToastUtil.success(response.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDiscard = async () => {
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to discard all changes?'
    );
    if (isConfirmed) {
      setStatus(0);
      setName('');
      setDescription('');
      setHowToSetup('');
      setUploads([]);
    }
  };

  const validateForm = () => {
    if (parseInt(client) === 0 || !client) {
      ToastUtil.error('Please select a Client!');
      return false;
    }

    if (parseInt(site) === 0 || !site) {
      ToastUtil.error('Please select a Site!');
      return false;
    }

    if (parseInt(selectedAssociate) === 0 || !selectedAssociate) {
      ToastUtil.error('Please select a Associate!');
      return false;
    }

    if (parseInt(type) === 0 || !type) {
      ToastUtil.error('Please select a Type!');
      return false;
    }

    if (!amount) {
      ToastUtil.error('Please input Amount!');
      return false;
    }

    if (parseInt(status) === 0 || !status) {
      ToastUtil.error('Please select a Status!');
      return false;
    }

    if (uploads.length <= 0) {
      ToastUtil.error('Please insert Document to Upload!');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to add this Claim?'
      ))
    ) {
      const selectedSite = availableSites.find(
        (option) => Number(option.id) === Number(site)
      );
      let formData = new FormData();
      formData.append('associate_id', selectedAssociate);
      formData.append('type_id', type);
      formData.append('date_of_receipt', dateReceipt); // ✅ Added missing field
      formData.append('amount', amount);
      formData.append('mp_remarks', remarks);
      formData.append('status', status);
      formData.append('client_id', client);
      formData.append('site_id', site);
      formData.append('file', uploads[0]);

      // ✅ Claim Percentage / Limit logic
      let deductAmount = 0;
      if (selectedSite?.enable_claim_limit) {
        if (selectedSite?.enable_claim_percentage) {
          if (selectedAssociate?.claim_percentage) {
            deductAmount =
              amount * parseFloat(selectedAssociate.claim_percentage / 100);
          } else {
            deductAmount = amount;
          }
        } else {
          deductAmount = amount;
        }

        if (Number(selectedSite.claimBalance) - Number(deductAmount) < 0) {
          deductAmount = selectedSite.claimBalance;
        }
      } else {
        if (selectedSite?.enable_claim_percentage) {
          if (selectedAssociate?.claim_percentage) {
            deductAmount =
              amount * parseFloat(selectedAssociate.claim_percentage / 100);
          } else {
            deductAmount = amount;
          }
        } else {
          deductAmount = amount;
        }
      }

      formData.append('deduct_amount', deductAmount);
      formData.append(
        'claim_settings',
        JSON.stringify({
          enable_claim_limit: selectedSite?.enable_claim_limit,
          enable_claim_percentage: selectedSite?.enable_claim_percentage,
          claim_limit: selectedAssociate?.claim_limit || null,
        })
      );

      let api_path = `/claims`;
      let response = await newFetch(POST, api_path, formData, 'multi');

      if (response.success) {
        ToastUtil.success(response.message || 'Claim submitted successfully');
        history.push('/claims');
      } else {
        ToastUtil.error(response.message || 'Failed to submit claim');
      }
    }
  };

  useEffect(() => {
    setClient(selectedClientID);
    fetchClients(selectedClientID);
  }, [selectedClientID]);

  useEffect(() => {
    const selectedSite = availableSites.some(
      (option) => Number(option.id) === Number(siteID)
    )
      ? siteID
      : availableSites.length === 1
        ? availableSites[0].id
        : '';

    setSite(selectedSite);
  }, [siteID, availableSitesKey]);

  useEffect(() => {
    setSelectedAssociate(0);
    fetchAssociates(site);
    fetchTypes(site);
  }, [clientID, site]);

  useEffect(() => {
    fetchStatusOptions();
    fetchClientsOptions(accessType);
    fetchSiteOptions();
  }, []);

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to="/claims"
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to Claim
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Add New Claim</h5>
              </div>
            </div>
            {selectedClient?.enable_claims ? (
              <>
                <form className="form" onSubmit={(e) => handleSubmit(e)}>
                  <div
                    style={{
                      marginTop: '1rem',
                      paddingLeft: '3rem',
                      paddingRight: '3rem',
                      paddingBottom: '6rem',
                    }}
                  >
                    <div className="d-flex border rounded adjust-shadow">
                      <div
                        className="flex-grow-1 bg-white col-md-7"
                        style={{ padding: '2.25rem' }}
                      >
                        <div
                          className="row pb-3 col-md-12"
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <strong>Client</strong>
                          <p
                            style={{
                              fontSize: 20,
                              color: '#595b5f',
                              fontWeight: 500,
                              paddingLeft: 8,
                            }}
                          >
                            {client_options &&
                              selectedClientID &&
                              client_options.find(
                                (clnt) => clnt.id === parseInt(selectedClientID)
                              )?.name}
                          </p>
                        </div>
                        <div className="row pb-3 col-md-8">
                          <strong>Site*</strong>
                          <select
                            name="site"
                            className="form-select mt-3 adjust-fs"
                            value={site}
                            onChange={(e) => setSite(e.target.value)}
                          >
                            <option value="">Select Site</option>
                            {availableSites.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="row pb-3 col-md-8">
                          <strong>Associate Name*</strong>
                          <select
                            name="selectedAssociate"
                            className="form-select mt-3 adjust-fs"
                            value={selectedAssociate}
                            onChange={(e) =>
                              setSelectedAssociate(e.target.value)
                            }
                          >
                            <option value={0}>Select Associate</option>
                            {associates &&
                              associates.map((assoc, index) => (
                                <option
                                  key={`${assoc.id}_${index}`}
                                  value={assoc.id}
                                >
                                  {assoc.first_name + ' ' + assoc.last_name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="row pb-3 col-md-8">
                          <strong>Type*</strong>
                          <select
                            name="type"
                            className="form-select mt-3 adjust-fs"
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                          >
                            <option value={0}>Select Type</option>
                            {claimTypes &&
                              claimTypes.map((data, index) => (
                                <option
                                  key={`${data.id}_${index}`}
                                  value={data.id}
                                >
                                  {data.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="row pb-3 col-md-8">
                          <strong>Date of Receipt*</strong>
                          <input
                            type="date"
                            className="form-control mt-3 adjust-fs w-50"
                            value={dateReceipt}
                            onChange={({ target: { value } }) =>
                              setDateReceipt(value)
                            }
                          />
                        </div>

                        <div className="row pb-3 col-md-8">
                          <strong>Amount*</strong>
                          <input
                            type="number"
                            className="form-control mt-3 adjust-fs w-25"
                            placeholder="Amount"
                            value={amount}
                            onChange={({ target: { value } }) =>
                              setAmount(value)
                            }
                          />
                        </div>
                        <div
                          className="flex-grow-1 bg-white col-md-5"
                          style={{ paddingTop: '2.25rem' }}
                        >
                          <div className="row pb-3 col-md-12">
                            <div className="col-12">
                              <strong>Upload Files</strong>
                            </div>
                            <div className="pt-3 col-12">
                              <Upload
                                files={uploads}
                                setFiles={setUploads}
                                multiple={true}
                                accept={' image/jpg, image/jpeg, image/png'}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row pb-3 col-md-8">
                          <strong>Status*</strong>
                          <select
                            name="status"
                            className="form-select mt-3 adjust-fs w-25"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <option value={0}>Select Status</option>
                            {statusOptions &&
                              statusOptions.map((data, index) => (
                                <option
                                  key={`${data.id}_${index}`}
                                  value={data.value}
                                >
                                  {data.label}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div className="row pb-3 col-md-12">
                          <strong>Remarks</strong>
                          <textarea
                            rows="10"
                            className="form-control mt-3 adjust-fs"
                            style={{ resize: 'none' }}
                            placeholder="Remarks"
                            value={remarks}
                            onChange={({ target: { value } }) =>
                              setRemarks(value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      position: 'fixed',
                      bottom: 0,
                      width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                      height: '4.5rem',
                      paddingRight: '3rem',
                    }}
                    className="border-top bg-white d-flex align-items-center justify-content-end"
                  >
                    <button
                      type="button"
                      className="btn btn-outline-brand adjust-fs adjust-shadow"
                      style={{ width: '12rem' }}
                      onClick={handleDiscard}
                    >
                      Discard
                    </button>
                    <button
                      type="submit"
                      className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                      style={{ width: '12rem' }}
                    >
                      Save changes
                    </button>
                  </div>
                </form>
              </>
            ) : (
              <div
                className="text-muted pt-4"
                style={{
                  marginTop: '1rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                The client does not have access to this module.
              </div>
            )}
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddClaim);
